import htmx from 'htmx.org';
window.htmx = htmx

import * as Popper from '@popperjs/core'
window.Popper = Popper

import TomSelect from 'tom-select'
window.TomSelect = TomSelect

import * as easepick from '@easepick/bundle'
window.easepick = easepick

import '../sass/app.scss'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
// import Alert from 'bootstrap/js/dist/alert'
import Tooltip from 'bootstrap/js/dist/tooltip'
// import Toast from 'bootstrap/js/dist/toast'
import Popover from 'bootstrap/js/dist/popover'
import Masonry from 'masonry-layout';
window.Masonry = Masonry;


import '@iconify/iconify'
import 'pwacompat'

import '../assets/js/custom.jsx'

// Initialize Masonry on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    // Find the Masonry container on the page
    const initializeMasonry = (containerId, itemSelector, columnWidthSelector) => {
        const masonryContainer = document.getElementById(containerId);

        // If the container exists, initialize Masonry on it
        if (masonryContainer) {
            if (typeof Masonry !== 'undefined') {
                // Store the instance on the element itself so it can be accessed by other scripts
                masonryContainer.masonry = new Masonry(masonryContainer, {
                    itemSelector: '.col-md-6', // These are the direct children items to be laid out
                    columnWidth: '.col-md-6',  // Helps Masonry calculate column widths, especially with percentPosition
                    percentPosition: true,
                });
            } else {
                // This case should ideally not happen if the import is correct
                console.error('Masonry class is undefined in app.js even after import.');
            }
        }
    };

    // Initialize for My NLA page
    // The itemSelector and columnWidth are also '.col-md-6' for the My NLA page cards
    initializeMasonry('my-nla-cards-masonry-container', '.col-md-6', '.col-md-6');

    // Initialize for Community Info page
    // The itemSelector and columnWidth are also '.col-md-6' for the Community Info page cards
    initializeMasonry('community-info-cards-masonry-container', '.col-md-6', '.col-md-6');

    // Initialize for admin page
    // The itemSelector and columnWidth are both '.col-md-6' for the admin page cards
    initializeMasonry('admin-cards-masonry-container', '.col-md-6', '.col-md-6');


    // Theme Toggler Logic
    const themeTogglers = document.querySelectorAll('.theme-toggler-btn'); // Use querySelectorAll with a class
    const htmlElement = document.documentElement;

    const updateAllTogglerAppearances = (theme) => { // Renamed for clarity
        themeTogglers.forEach(themeToggler => {
            if (!themeToggler) { // Should not happen if querySelectorAll found elements
                console.log('[ThemeToggler] A themeToggler element instance was unexpectedly null.'); // DEBUG
                return;
            }

            // 1. Determine the new icon name based on the theme
            const newIconName = theme === 'dark' ? 'bi:sun-fill' : 'bi:moon-stars-fill';

            // 2. Construct the HTML string for the new icon span
            // Ensure styles match what's in main-menu.blade.php
            const iconHtml = `<span class="iconify fs-4" data-icon="${newIconName}" style="border:0 !important;" ></span>`;

            // 3. Replace the button's content with the new icon span
            themeToggler.innerHTML = iconHtml;

            // 4. Tell Iconify to scan the button (which now contains the new span)
            // This will find the new span and render the icon.
            if (window.Iconify && typeof window.Iconify.scan === 'function') {
                window.Iconify.scan(themeToggler);
            } else {
                console.error('[ThemeToggler] Iconify.scan is not available or Iconify not loaded for a toggler.'); // DEBUG
            }
        });
    };

    // Set initial toggler appearance based on the current theme
    // Server now sets data-bs-theme, so we read it and sync localStorage
    const initialTheme = htmlElement.getAttribute('data-bs-theme');
    if (initialTheme) { // initialTheme could be null if attribute isn't set, though unlikely with default
        localStorage.setItem('bsTheme', initialTheme); // Sync localStorage with server-set theme
    }
    updateAllTogglerAppearances(initialTheme);

    themeTogglers.forEach(themeToggler => {
        themeToggler.addEventListener('click', () => {
            const currentTheme = htmlElement.getAttribute('data-bs-theme');
            const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

            htmlElement.setAttribute('data-bs-theme', newTheme);
            localStorage.setItem('bsTheme', newTheme);
            updateAllTogglerAppearances(newTheme);

            // Send the new theme to the server
            fetch("/set-theme", { // Using static path
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ theme: newTheme })
            })
                .then(response => response.json())
                .then(data => {
                    console.log('[ThemeToggler] Server response:', data);
                })
                .catch(error => {
                    console.error('[ThemeToggler] Error saving theme to server:', error);
                });
        });
    });

    // Optional: Respect system preference if no user preference is set
    // This part is commented out but shows how you could initialize based on `prefers-color-scheme`
    // if (!localStorage.getItem('bsTheme') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //    htmlElement.setAttribute('data-bs-theme', 'dark');
    //    updateTogglerAppearance('dark');
    // }


});
